import DialogComponent from "components/Dialog";

export default class AddPaymentWay extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            name: ""
        };

        this.state = {
            ...this.defaultState
        };
    }

    show(hideCb) {
        this.dialogTitle = "Добавить способ оплаты";
        this.hidCb = hideCb;
        super.show();
    }

    save() {
        const info = {
            name: this.state.name,
            type: "OTHER",
            paymentWaysHasBranchesList: [],
            subtractPriorityLevel: 0
        };

        if (this.hidCb?.apply)
            this.hidCb(info);

        this.hide();
    }

    renderContent() {
        return (
            <div className="content flex col gap24">
                {this.insertInput({
                    label: "Название для формы оплаты",
                    placeHolder: "Введите название для формы оплаты",
                    onChange: this.changeState.bind(this, "name")
                })}
            </div>
        );
    }
}
